export default __webpack_public_path__ + "static/media/FlyingFrog9.ceeff704.png";